import { Button, Card, Carousel, Col, Row } from 'react-bootstrap';
import Box from '@mui/material/Box';
import { Tabs } from '@mui/material';
import Tab from '@mui/material/Tab';
import { User } from '../../../../../model/user/User';
import { RatingStar } from '../../../../../shared/components/RatingStar';
import { numberFormatter } from '../../../../../utils/helpers/numberFormater';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { CustomImageHandler } from '../../../../../shared/components/CustomImageHandler';
import { getSocialIcons, isDateInPast } from '../../../../../shared/functions/Functions';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import Flag from '../../../../../shared/components/flag/Flag';
export interface IInviteTab {
    user: User;
    openContractModal: (userId: number) => void;
}

export function InviteContractCardItem({ user, openContractModal }: IInviteTab) {
    const { t } = useTranslation();
    const [value, setValue] = useState(0);
    const { campaign } = useSelector((states: IAllStates) => states.selectedCampaign);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    function a11yProps(index: number) {
        return {
            id: `vertical-tab-${index}`,
            'aria-controls': `vertical-tabpanel-${index}`,
        };
    }

    return (
        <Card className="booking-card h-100 mb-3 position-relative border-top-0 border-right-0 ">
            <div className="d-flex flex-column flex-md-row p-3 justify-content-between align-items-center">
                <div
                    onClick={() => openContractModal(user.id)}
                    className="d-flex align-items-center cursor-pointer w-md-50"
                >
                    <div className="position-relative">
                        <CustomImageHandler
                            altTag={user?.profilePhoto?.name ?? ''}
                            classes="user-img-rounded"
                            thumbnailPath={user?.profilePhoto?.thumbnail}
                            photoPath={user?.profilePhoto?.path ?? null}
                            name={user?.displayName}
                        />
                    </div>
                    <div className="px-2 d-flex align-items-center">
                        <h6 className="mb-0">{user?.displayName}</h6>
                        {user?.totalRating ? <RatingStar rating={user?.totalRating} /> : ''}
                    </div>
                </div>
                <div className="d-flex overflow-auto w-100 justify-content-md-end">
                    <Box>
                        <Tabs
                            className="border-0"
                            variant="scrollable"
                            scrollButtons={false}
                            value={value}
                            onChange={handleChange}
                            aria-label="Vertical tabs example"
                            sx={{ borderRight: 1, borderColor: 'divider' }}
                            TabIndicatorProps={{
                                style: {
                                    backgroundColor: '#05bbc9',
                                },
                            }}
                        >
                            {user?.totalPlatforms.map((platform, index) => (
                                <Tab
                                    key={index}
                                    style={{ minWidth: 50, maxWidth: 55, padding: 0 }}
                                    label={getSocialIcons({
                                        iconPath: platform.path,
                                        classes: 'platform-icon-size  p-0 ',
                                    })}
                                    {...a11yProps(index)}
                                />
                            ))}
                        </Tabs>
                    </Box>
                </div>
            </div>
            <Row className=" h-100 px-3 pb-3 m-0 w-100">
                <Col
                    className="p-md-0 cursor-pointer position-relative"
                    md={3}
                    onClick={() => openContractModal(user.id)}
                >
                    <Carousel controls={false} indicators={false} id="booking-carousel">
                        {user?.feedItems.length > 0 ? (
                            user?.feedItems?.map(item =>
                                item.postImages.length > 0 ? (
                                    <Carousel.Item key={item.id} className="position-relative">
                                        <CustomImageHandler
                                            altTag={item.postImages[0]?.name ?? ''}
                                            classes="booking-card-image"
                                            thumbnailPath={item.postImages[0]?.thumbPath}
                                            photoPath={item.postImages[0]?.path ?? null}
                                        />
                                    </Carousel.Item>
                                ) : null
                            )
                        ) : (
                            <Carousel.Item>
                                <CustomImageHandler
                                    altTag={user?.profilePhoto?.name ?? ''}
                                    classes="booking-card-image"
                                    photoPath={user?.profilePhoto?.path ?? ''}
                                    thumbnailPath={user?.profilePhoto?.thumbnail}
                                />
                            </Carousel.Item>
                        )}
                    </Carousel>
                    {user?.agencyCompany?.id && (
                        <div className="offer-by-agency-wrapper w-100">
                            <div className="offer-by-agency-badge">
                                <img src="/icons/building-icon.svg" alt="Building icon" />
                                <span className="pl-1">
                                    {t('general.offerByAgency')}
                                    <br />
                                    <span className="text-primary">{user?.agencyCompany?.displayName ?? ''}</span>
                                </span>
                            </div>
                        </div>
                    )}
                </Col>
                <Col md={9} className="d-flex flex-column justify-content-between pr-0">
                    {user?.totalPlatforms.map((platform, index) => (
                        <TabPanel index={index} value={value} key={platform?.id}>
                            <Row className="cursor-pointer" onClick={() => openContractModal(user.id)}>
                                <Col md={6}>
                                    <div className="d-flex flex-column ">
                                        <div className=" d-flex py-1 ">
                                            <span>{t('brand.campaign.book.invite.followers')} : </span>
                                            <h6 className="text-primary mx-1 mb-0">
                                                {numberFormatter(platform?.followers)}
                                            </h6>
                                        </div>
                                        <div className=" d-flex py-1 ">
                                            <span>{t('brand.campaign.book.invite.avg_reach')} :</span>
                                            <h6 className="text-primary mx-1 mb-0">
                                                {numberFormatter(platform?.reach)}
                                            </h6>
                                        </div>
                                        <div className=" d-flex py-1">
                                            <span>{t('brand.campaign.book.invite.engagement_rate')} : </span>
                                            <h6 className="text-primary mx-1 mb-0">
                                                {platform?.engagementRate
                                                    ? `${Number(platform?.engagementRate).toFixed(2)}%`
                                                    : 'n.a'}
                                            </h6>
                                        </div>
                                        {/*<div className=" d-flex py-1">*/}
                                        {/*    <span>{t('brand.campaign.book.invite.audience_score')} :{' '}</span>*/}
                                        {/*    <h6 className="text-primary mx-1 mb-0">*/}
                                        {/*        {user?.totalEngagements}%*/}
                                        {/*    </h6>*/}
                                        {/*</div>*/}
                                    </div>
                                </Col>
                                <Col md={6} className="p-0">
                                    <div>
                                        <span className="mx-1">
                                            {t('brand.campaign.book.invite.audience_per_country')}
                                        </span>
                                        <div className="d-flex flex-wrap overflow-auto">
                                            {platform.audiences?.slice(0, 3).map((audience, index) => (
                                                <div
                                                    key={index}
                                                    className="d-flex align-items-center mx-1 country-flagData-width"
                                                >
                                                    <Flag
                                                        code={audience.metric}
                                                        width={30}
                                                        className="rounded"
                                                        placement="top"
                                                    />
                                                    <div className="d-flex mx-1 flex-column ">
                                                        <span className="text-primary font-weight-bold mb-0">
                                                            {Math.round(audience.value)}%
                                                        </span>
                                                        <span className="text-secondary mb-0">
                                                            {numberFormatter(audience.followers)}
                                                        </span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </TabPanel>
                    ))}
                    <div className="d-flex w-100 justify-content-end mb-3 mb-md-0">
                        <Button
                            onClick={() => openContractModal(user.id)}
                            variant="primary"
                            size="sm"
                            className="mt-3"
                            disabled={isDateInPast(campaign?.publishTo ?? '')}
                        >
                            {t('brand.campaign.book.invite.invite')}
                        </Button>
                    </div>
                </Col>
            </Row>
        </Card>
    );
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
